export const CHECKBOX_DOM_ID = 'recaptcha-checkbox'
